<template>
  <div v-if="activeLens" class="viq-lens-indicator">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M7 1L9 5.5L14 6.5L10.5 10L11.5 14L7 12L2.5 14L3.5 10L0 6.5L5 5.5L7 1Z" fill="currentColor" />
    </svg>
    <span class="viq-lens-indicator__name">Lens: {{ activeLens.name }}</span>
    <button class="viq-lens-indicator__clear" title="Clear lens" @click="clearLens">
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path d="M2 2l6 6M8 2l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ViqLensIndicator",
  computed: {
    ...mapState("Viq", ["activeLens"]),
  },
  methods: {
    clearLens() {
      this.$store.commit("Viq/SET_ACTIVE_LENS", null);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-lens-indicator {
  display: inline-flex;
  align-items: center;
  gap: $viq-space-sm;
  padding: $viq-space-xs $viq-space-md;
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: $viq-radius-full;
  font-size: $viq-font-sm;
  color: #92400e;
  margin-bottom: $viq-space-md;
  width: fit-content;

  &__name {
    font-weight: 600;
  }

  &__clear {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: none;
    background: none;
    color: #92400e;
    cursor: pointer;
    border-radius: 50%;
    transition: background $viq-transition-fast;

    &:hover {
      background: rgba(245, 158, 11, 0.15);
    }
  }
}
</style>
